<template>
  <div class="pageContent scrollDiv" style="position:absolute;">
    <!--酒店品牌-->
    <mu-popover :open="SwitchTab1" style="width:100%" :autoPosition="false" :trigger="trigger" @close="handleClose()" :anchorOrigin="anchorOrigin" :targetOrigin="targetOrigin">
      <div style="width:7.5rem ; padding:0rem 0.2rem ; color:#333 ; font-size:0.28rem;">
        <!--{{ BrandID }}-->
        <div v-on:click="ChangeBrand(index)" v-bind:class="{ GreeenFont: BrandID.indexOf(index) != -1  }" v-for=" (item,index) in BrandList " :key="index" class="TopMenuList">
          {{ item }}
          <img src='../../../static/search/HotelList/multi_choose.png' v-if="BrandID.indexOf(index) != -1 " class=" RightAnNiu " />
          <img src='../../../static/search/HotelList/multi_unchoose.png' v-if="  BrandID.indexOf(index) == -1 " class=" RightAnNiu " />
        </div>
        <input type="button" value="确 定" v-on:click="LimitBrand()" style="" class="GreenButton" />
        <!--<div style="height:0.3rem" >      </div>-->
      </div>
    </mu-popover>

    <!--设施服务-->
    <mu-popover :open="SwitchTab2" style="width:100%" :autoPosition="false" :trigger="trigger" @close="handleClose()" :anchorOrigin="anchorOrigin" :targetOrigin="targetOrigin">
      <div style="width:7.5rem ; padding:0rem 0.2rem ; color:#333 ; font-size:0.28rem;">
        <div v-on:click="ChangeService(index)" v-bind:class="{ GreeenFont: ServiceID.indexOf(index) != -1  }" v-for=" (item,index) in ServiceList " :key="index" class="TopMenuList">
          {{ item }}
          <img src='../../../static/search/HotelList/multi_choose.png' v-if="ServiceID.indexOf(index) != -1 " class=" RightAnNiu " />
          <img src='../../../static/search/HotelList/multi_unchoose.png' v-if="  ServiceID.indexOf(index) == -1 " class=" RightAnNiu " />
        </div>
        <input type="button" value="确 定" v-on:click="LimitService()" style="" class="GreenButton" />
      </div>
    </mu-popover>
    
    <!--酒店促销-->
    <mu-popover :open="SwitchTab3" style="width:100%" :autoPosition="false" :trigger="trigger" @close="handleClose()" :anchorOrigin="anchorOrigin" :targetOrigin="targetOrigin">
      <div style="width:7.5rem ; padding:0rem 0.2rem ; color:#333 ; font-size:0.28rem;">
        <div v-on:click="ChangeDiscount(index)" v-for=" (item,index) in DiscountList " :key="index" v-bind:class="{ GreeenFont: DiscountID.indexOf(index) != -1  }" class="TopMenuList">
          {{ item }}
          <img src='../../../static/search/HotelList/multi_choose.png' v-if="DiscountID.indexOf(index) != -1 " class=" RightAnNiu " />
          <img src='../../../static/search/HotelList/multi_unchoose.png' v-if="  DiscountID.indexOf(index) == -1 " class=" RightAnNiu " />
        </div>
        <input type="button" value="确 定" v-on:click="LimitDiscount()" style="" class="GreenButton" />
      </div>
    </mu-popover>

    <!--排序单选-->
    <mu-popover :open="SwitchTab4" style="width:100%" :autoPosition="false" :trigger="trigger" @close="handleClose()" :anchorOrigin="anchorOrigin" :targetOrigin="targetOrigin">
      <div style="width:7.5rem ; padding:0rem 0.2rem ; color:#333 ; font-size:0.28rem;">
        <div v-on:click="ChangeSort(index)" v-for=" (item,index) in SortList " :key="index" v-bind:class="{ GreeenFont: SortID == index  }" class="TopMenuList">
          {{ item }}
          <img src='../../../static/search/HotelList/single_choose.png' v-if="SortID == index " class=" RightAnNiu " />
          <img src='../../../static/search/HotelList/single_unchoose.png' v-if="  SortID != index " class=" RightAnNiu " />
        </div>
      </div>
    </mu-popover>

    <div style='width:7.5rem;top:0px;z-index:99'>
      <!--标题-->
      <pageTitle @titleHandler='goCity' :showTitleIcon='true' :title='g_city.name' :showRight='true' rightTitle='地图找房' @rightHandler='gomapSearch' :bottomExtend='true'/>
      <!--日期-->
      <div class="topBlock whiteBg radius">
        <div class="left">
          <small>入住</small><br/>
          <div style='width:100%;position:relative;'>
            <mu-date-picker style='z-index:100;' class='date' :maxDate="checkinMaxDate" :minDate="checkinMinDate" format='YYYY-MM-DD' :fullWidth='true' v-model="g_searchParam.startDate" :underlineShow='false' hintTextClass="date" inputClass="dpicker" @change="checkinDateChange" />
            <span class='formatdate'>{{checkInDateFormat}}</span>
          </div>

          <div v-if="g_searchParam.isZeroRoom" style="     ;position:absolute;margin:-1.5rem 0 0 0rem ; z-index:999999 ; width:2.5rem ; height: 1.1rem">
            <!-- 用来阻挡选择日期，只有在使用凌晨房的时候阻挡 -->
          </div>
        </div>

        <div class="middle" >
          住<span>{{day}}</span>晚
        </div>

        <div class="right">
          <small>离店</small><br/>
          <div style='width:100%;position:relative;'>
            <mu-date-picker class='date' :maxDate="checkoutMaxDate" :minDate="checkoutMinDate" format='YYYY-MM-DD' :fullWidth='true' v-model='g_searchParam.endDate' :underlineShow='false' hintTextClass="date" inputClass="dpicker" @change="checkoutDateChange" />
            <span class='formatdate'>{{checkOutDateFormat}}</span>
          </div>
        </div>
        
      </div>
    </div>
    <!--搜索框-->
    <div class="searchDiv">
      <span @click="selectKey">
        <span class="icon">
          <mu-icon :size='19' value="search" />
        </span>
        {{ this.g_searchKeyWord }}
      </span>
    </div>
    <div style='width:7.5rem'>
      <!--条件检索-->
      <div style=" width:100% ;    background-color:white; border-bottom:1px #eee solid;  ">
        <mu-tabs @change="handleTabChange">
          <mu-tab style='font-weight:500' value="tab1" v-on:click="toggle(1)" ref="button1">
            <span v-bind:class="{ GreeenFont: SwitchTab1 || BrandID[0] != 0  }">酒店品牌</span>
            <div style="margin-top:-0.03rem;   float:right">
              <img src='../../../static/search/HotelList/filter_fold.png' v-if=" SwitchTab1 " />
              <img src='../../../static/search/HotelList/filter_unfold.png' v-else />
            </div>
          </mu-tab>
          <mu-tab style='font-weight:500' value="tab1" v-on:click="toggle(2)">
            <span v-bind:class="{ GreeenFont: SwitchTab2 || ServiceID[0] != 0   }">设施服务</span>
            <div style="margin-top:-0.03rem;   float:right">
              <img src='../../../static/search/HotelList/filter_fold.png' v-if=" SwitchTab2 " />
              <img src='../../../static/search/HotelList/filter_unfold.png' v-else />
            </div>
          </mu-tab>
          <mu-tab style='font-weight:500' value="tab1" v-on:click="toggle(3)">
            <span v-bind:class="{ GreeenFont: SwitchTab3 || DiscountID[0] != 0   }">酒店促销</span>
            <div style="margin-top:-0.03rem;   float:right">
              <img src='../../../static/search/HotelList/filter_fold.png' v-if=" SwitchTab3 " />
              <img src='../../../static/search/HotelList/filter_unfold.png' v-else />
            </div>
          </mu-tab>
          <mu-tab style='font-weight:500' value="tab1" v-on:click="toggle(4)">
            <span v-bind:class="{ GreeenFont: SwitchTab4 || SortID != 0   }">排序方式</span>
            <div style="margin-top:-0.03rem;    float:right">
              <img src='../../../static/search/HotelList/filter_fold.png' v-if=" SwitchTab4 " />
              <img src='../../../static/search/HotelList/filter_unfold.png' v-else />
            </div>
          </mu-tab>

          <!--<mu-tab style='font-weight:500' value="tab3" title="好评" />
            <mu-tab style='font-weight:500' value="tab4" title="距离" />
            <mu-tab style='font-weight:500' value="tab2" title="价格" />-->
        </mu-tabs>
      </div>

      <!--加载动画-->
      <div v-if="showTree" style="text-align:center;padding:1rem 0 0 0; background-color:#F1F1F1  ">
        <img src="../../../static/LoadingBest.gif" style=" width:1.2rem ;" />
      </div>

      <!--酒店列表-->
      <hotelList :HotelList='HotelList' />

      <loadListTail :showExtend='true' mainTitle='没有找到符合条件的酒店哦，建议您更换搜索条件' :showContact='true' subTitle="为您推荐" subIcon='good' :noMore='stop' :isLoading='fetching' :overZero='HotelList.length > 0' />

      <!--加载动画-->
      <div v-if="!stop && !showTree" style="text-align:center;margin:0;">
        <img src="../../../static/LoadingBest.gif" style=" width:1.2rem ;" />
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import service from '../../utils/hotelService.js'
import date from '../../utils/dateextend'
import loadListTail from '../../components/loadListTail'
import hotelList from '../../components/hotelList'

export default {
  data() {
    return {

      BrandID: [0],
      BrandList: ['全部酒店',  '格林东方酒店','格美酒店', '格雅酒店', '格菲酒店', '格林豪泰酒店', '格林联盟酒店', '青皮树酒店', '贝壳酒店','格林公寓'],
      // 00 40 30 50 70 
      HotelTypeIdList: '',

      ServiceID: [0],
      ServiceList: ['不限', '早餐', '停车场', '会议室', '客房wifi', '接待外宾','自助机'],

      DiscountID: [0],
      DiscountList: ['不限', '99.8特惠房', 'K币换房', '代金券', '连住特惠', '特惠房','单店活动', '安心房'],

      SortID: 0,
      SortList: ['推荐', '好评', '距离', '价格由低到高', '价格由高到低'],

      HotelList: [],
      listByComment: [],
      // loading: false,
      scroller: null,
      activeTab: 'tab1',
      isSuccess: true,
      queryParam: '',
      currentPage: '0',
      page: '0',
      stop: false,
      change: false,
      lastScrollY: '',
      fetching: false,


      showTree: true,
      flag: 0,
      // 按钮 开关 显示位置 
      SwitchTab1: false,
      SwitchTab2: false,
      SwitchTab3: false,
      SwitchTab4: false,
      trigger: null,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      targetOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      // 按钮 开关 显示位置   END
    }
  },
  components: {
    //酒店列表组件，列表尾巴组件
    hotelList, loadListTail
  },
  mounted() {
    this.showTree = true
    this.scroller = this.$el;

    this.trigger = this.$refs.button1.$el
  },
  created() {
    var searchParam = this.g_searchParam;
    searchParam.Sort = 1;
    this.setG_searchParam(searchParam);


    this.change = true;
  },
  methods: {
    ...mapMutations([
      'setG_currentInfo', 'setG_searchParam','setG_searchKeyWord', "setG_UserInfo"
    ]),

    // 页面标签切换。以前是一切换，就根据状态加载数据。现在是进入子页面选择
    handleTabChange(val) {
      this.activeTab = val
    },

    goback() {
      // javascript: history.go(-1);
      
    if( this.$router.gxxfrom.path == '/search/key' )
    {
      this.$router.push({ path: '/home/index' });
    }
    else
      this.$router.go(-1)
      
    },
    gomapSearch() {
      var searchParam = this.g_searchParam;
      searchParam.IsRelaxMap = false;
      this.setG_searchParam(searchParam);

      this.$router.push({ path: '/search/mapSearch' });
    },

    // 开关选项标签
    toggle(index) {
      if (index == 1) {

        // 计划往下挪一点
        var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        var maxScroll = document.documentElement.scrollHeight || document.body.scrollHeight;
        var maxWidth = document.documentElement.scrollWidth || document.body.scrollWidth ;

        window.scrollTo(0,  maxWidth/3-5);


        this.SwitchTab2 = false
        this.SwitchTab3 = false
        this.SwitchTab4 = false
        this.SwitchTab1 = !this.SwitchTab1
      }
      else if (index == 2) {
        this.SwitchTab1 = false
        this.SwitchTab3 = false
        this.SwitchTab4 = false
        this.SwitchTab2 = !this.SwitchTab2
      }
      else if (index == 3) {
        this.SwitchTab1 = false
        this.SwitchTab2 = false
        this.SwitchTab4 = false
        this.SwitchTab3 = !this.SwitchTab3
      }
      else if (index == 4) {
        this.SwitchTab1 = false
        this.SwitchTab2 = false
        this.SwitchTab3 = false
        this.SwitchTab4 = !this.SwitchTab4
      }
    },
    handleClose() {
      this.SwitchTab1 = false
      this.SwitchTab2 = false
      this.SwitchTab3 = false
      this.SwitchTab4 = false
    },
    // 开关选项标签 END


    // 酒店品牌  多选切换
    ChangeBrand(index) {

      let i = 0;
      // 列表中存在0，且包含》1    把0去掉。
      this.BrandID.forEach(function(ele) {
        if (ele == 0 && this.BrandID.length > 0) {
          this.BrandID.splice(i, 1);
        }
      }, this);

      // 没有数据则插入数据
      if (this.BrandID.length == 0) {
        this.BrandID = this.BrandID.concat(index)
        return
      }

      // 常规多选

      let IsAdd = true;
      this.BrandID.forEach(function(ele) {

        if (ele == index) {
          IsAdd = false;
          this.BrandID.splice(i, 1);
        }
        i++;

        if (i == this.BrandID.length && IsAdd == true) {
          this.BrandID = this.BrandID.concat(index)
        }
      }, this);
      // 常规多选  END

      // 选中0 只剩0
      if (index == 0 || this.BrandID.length == 0 ) {
        this.BrandID = [0]
      }

    },
    // HotelTypeIdList
    // 品牌限制
    LimitBrand() {
      // 关闭窗口
      this.handleClose();
      //初始化状态
      this.initState()
      let i = 1;
      this.HotelTypeIdList = '';
      this.BrandID.forEach(function(ele) {

        if (ele == 1)
          this.HotelTypeIdList += '40';

        else if (ele == 2)
          this.HotelTypeIdList += '20';
        else if (ele == 3)
          this.HotelTypeIdList += '21';
        else if (ele == 4)
          this.HotelTypeIdList += '22';
          
        else if (ele == 5)
          this.HotelTypeIdList += '00';
        else if (ele == 6)
          this.HotelTypeIdList += '30';
        else if (ele == 7)
          this.HotelTypeIdList += '50';
        else if (ele == 8)
          this.HotelTypeIdList += '70';
        
         else if (ele == 9)
          this.HotelTypeIdList += '81';

        else if(ele == 10)
          this.HotelTypeIdList += '90';

        

        // 最后一个不加分隔符
        if (i != this.BrandID.length)
          this.HotelTypeIdList += '|';

        if (ele == 0) {
          this.HotelTypeIdList = '';
          return
        }
        i++;
      }, this);
      //加载数据
      this.searchHotel()
    },
    // 酒店品牌  多选切换   END


    // 设施服务  多选切换
    ChangeService(index) {

      // 列表中存在0，且包含》1    把0去掉。
      this.ServiceID.forEach(function(ele) {
        if (ele == 0 && this.ServiceID.length > 0) {
          this.ServiceID.splice(i, 1);
        }
      }, this);

      // 没有数据则插入数据
      if (this.ServiceID.length == 0) {
        this.ServiceID = this.ServiceID.concat(index)
        return
      }

      // 常规多选
      let i = 0;
      let IsAdd = true;
      this.ServiceID.forEach(function(ele) {

        if (ele == index) {
          IsAdd = false;
          this.ServiceID.splice(i, 1);
        }
        i++;

        if (i == this.ServiceID.length && IsAdd == true) {
          this.ServiceID = this.ServiceID.concat(index)
        }
      }, this);
      // 常规多选  END

      // 选中0 只剩0
      if (index == 0 || this.ServiceID.length == 0 ) {
        this.ServiceID = [0]
      }
    },
    // 确定酒店限制
    // ServiceIDList
    LimitService() {
      // 关闭窗口
      this.handleClose();
      //初始化状态
      this.initState()

      this.ServiceIDList = [];
      //  ['不限', '早餐', '停车场', '会议室', '客房wifi', '接待外宾'],

      this.ServiceID.forEach(function(ele) {

        if (ele == 1)
          this.ServiceIDList.push(51)
        else if (ele == 2)
          this.ServiceIDList.push(41)
        else if (ele == 3)
          this.ServiceIDList.push(152)
        else if (ele == 4)
          this.ServiceIDList.push(215)
        else if (ele == 5)
          this.ServiceIDList.push(91)
        else if (ele == 6)
          this.ServiceIDList.push(189)

        if (ele == 0) {
          this.HotelTypeIdList = '';
          return
        }
      }, this);
      //加载数据
      this.searchHotel()
    },

    // 不同折扣  多选切换
    ChangeDiscount(index) {

      // 列表中存在0，且包含》1    把0去掉。
      this.DiscountID.forEach(function(ele) {
        if (ele == 0 && this.DiscountID.length > 0) {
          this.DiscountID.splice(i, 1);
        }
      }, this);

      // 没有数据则插入数据
      if (this.DiscountID.length == 0) {
        this.DiscountID = this.DiscountID.concat(index)
        return
      }

      // 常规多选
      let i = 0;
      let IsAdd = true;
      this.DiscountID.forEach(function(ele) {

        if (ele == index) {
          IsAdd = false;
          this.DiscountID.splice(i, 1);
        }
        i++;

        if (i == this.DiscountID.length && IsAdd == true) {
          this.DiscountID = this.DiscountID.concat(index)
        }
      }, this);
      // 常规多选  END
      if (index == 0) {
        this.DiscountID = [0]
        return
      }

      // 选中0 只剩0
      if (index == 0 || this.DiscountID.length == 0 ) {
        this.DiscountID = [0]
      }
    },
    // promotionType
    // 品牌限制
    LimitDiscount() {
      // 关闭窗口
      this.handleClose();
      //初始化状态
      this.initState()
      let i = 1;
      this.promotionType = '';

      // ['不限', '99.8特惠房', 'K币换房', '代金券', '连住特惠','特惠房','单店活动','安心房'],
      this.DiscountID.forEach(function(ele) {

        this.promotionType += ele;
        // 最后一个不加分隔符
        // if (i != this.DiscountID.length)
        this.promotionType += ',';

        if (ele == 0) {
          this.promotionType = '';
          return
        }
       if (ele == 5) {
       console.log('8888888888')
         this.flag=1;
      }
      else{ this.flag=0;}
        i++;
      }, this);
      //加载数据
      this.searchHotel()
    },


    // 排序 单选
    ChangeSort(index) {
      // 关闭窗口
      this.handleClose();
      //初始化状态
      this.initState()
      // 赋值
      this.SortID = index;
      // 搜索
      this.searchHotel()
    },



    loadMore() {
      if (this.stop == true) {
        window.removeEventListener('scroll', this.loadMore)
        return
      }
      var innerHeight = window.innerHeight;
      // 判断是否需要加载
      // document.body.offsetHeight;返回当前网页高度 
      if (window.scrollY + innerHeight + 200 > document.body.offsetHeight) {
        this.searchHotel();
      }
    },
    initState() {
      console.log('初始化状态')
      // 初始化状态
      this.stop = false
      this.HotelList = []
      this.page = 0
      // this.force = true
      this.showTree = true
      this.lastScrollY = ''
      this.fetching = false
      //重置滚动监听状态
      window.addEventListener('scroll', this.loadMore);
    },

    selectKey() {
      this.$router.push({ path: '/search/key' });
    },
    searchHotel() {
      console.log('初始化状态1111111111111')
      console.log(this.fetching)
      //状态锁，可以保证顺序正确
      if (this.fetching) {
        return;
      }
      else {
        this.fetching = true;
      }

      // 排序方式
      // var sort = this.activeTab.substring(3, 4)

      //  ['推荐', '好评', '距离', '价格由低到高', '价格由高到低', ''],
      var sort = 1;
      var SortType = 'asc'
    
 
      if (this.SortID == 0)
        sort = 1;
      else if (this.SortID == 1) {
        // 好评
        sort = 3;
        SortType = 'desc'
      }
      else if (this.SortID == 2){
        // 距离
        sort = 4;
        SortType = 'desc'
      }
      else if (this.SortID == 3)
        sort = 2;
      else if (this.SortID == 4) {
        // 好评
        sort = 2;
        SortType = 'desc'
      }
     
      if (this.$route.query.Flag=='1') {
          console.log('11112222')
          this.promotionType=7;  // 安心房
         }else if(this.$route.query.Flag=='2')
         {
            this.promotionType=5; // 特惠房
         }else if(this.$route.query.Flag=='3')
         {
            this.promotionType=4;  //连住特惠房
         }

            console.log('111111111')

      var params = new this.URLSearchParam();
      params.append('cityId', this.g_searchParam.cityId);
      params.append('hotelCode', this.g_searchParam.hotelCode);
      params.append('startDate', this.g_searchParam.startDate);
      params.append('endDate', this.g_searchParam.endDate);
      params.append('promotionType', this.promotionType);

      // 酒店类型
      // params.append('HotelTypeId', this.g_searchParam.HotelTypeId);
      params.append('HotelTypeId', this.HotelTypeIdList);
      params.append('ServiceIDList', this.ServiceIDList);

      params.append('areaId', this.g_searchParam.areaId);
      params.append('pointX', this.g_searchParam.pointX);
      params.append('pointY', this.g_searchParam.pointY);
      params.append('PointType', this.g_searchParam.PointType);
      params.append('PointText', this.g_searchParam.PointText);
      params.append('Sort', sort);
      params.append('Flag', this.flag);
      params.append('SortType', SortType);
      params.append('PageIndex', ++this.page);
      params.append('PageSize', this.g_searchParam.PageSize);
      this.$http.post(api.searchHotelList(), params.toParam()).then((res) => {

        if (res.Result) {
          // 状态变更
          this.showTree = false;
          // this.force = true
          this.fetching = false;
          // 状态变更     END
          var temp = res.Data;

          if (temp.length < 10) {
            this.stop = true;
            this.showTree = false;
            if (temp.length <= 0) {
              return;
            }
          }

          var HotelCodeList = "";

          temp.forEach(function(item) {

            item.ListGreen = [];
            item.ListYellow = [];

            if (HotelCodeList == "")
              HotelCodeList = HotelCodeList + item.HotelCode;
            else
              HotelCodeList = HotelCodeList + "|" + item.HotelCode;

          }, this);


          this.HotelList = this.HotelList.concat(temp);

          var params = new this.URLSearchParam();
          params.append('HotelCodeList', HotelCodeList);
          this.$http.post(api.GetHotelLabel(), params.toParam()).then((res) => {

            let i = 0;
            temp.forEach(function(item) {


              // 获取另外两个标签
              item.BBreak = res.Data.CanBuyBF[i];
              item.BRoom = res.Data.CanChoose[i];


              item.ListLabel = res.Data.label[i];
              i++;

              // 无数据，跳过
              if (item.ListLabel == undefined)
                return

              // vue数组刷新  赋值，
              item.ListLabel.forEach(function(ele) {

                if (ele.LabelType == "首图顶部") {
                  // item.LabelTop = ele.LabelName;
                  this.$set(item, "LabelTop", ele.LabelName)

                }
                else if (ele.LabelType == "首图底部") {

                  this.$set(item, "LabelBottom", ele.LabelName)
                }
                else if (ele.LabelType == "店名后方") {

                  this.$set(item, "LabelBack", ele.LabelName)
                }
                else if (ele.LabelType == "店名下方(定位类)") {

                  if (item.ListYellow == undefined)
                    item.ListYellow = [];

                  item.ListYellow = item.ListYellow.concat(ele.LabelName)
                }
                else if (ele.LabelType == "店名下方(评价类)") {

                  if (item.ListGreen == undefined)
                    item.ListGreen = [];

                  item.ListGreen = item.ListGreen.concat(ele.LabelName)
                }

              }, this);

              item.LabelCount = 0;
              if(item.BBreak)
                item.LabelCount ++ ;
              if(item.BRoom)
                item.LabelCount ++ ;


              item.LabelCount += item.ListYellow.length;
              item.LabelCount += item.ListGreen.length;



            }, this);
          }, this);
          console.log( temp )
        }
      })
    },
    //初始化日期
    initDate() {
      var nowDate = new Date();
      var inDate = nowDate.Format('yyyy-MM-dd')//入住日期为当天
      var outDate = nowDate.DateAdd('d', 1).Format('yyyy-MM-dd')  //离店日期为明天
      this.reWriteQueryDate(inDate, outDate);
    },
    //检查时间是否超时（入住时间小于今天）
    checkDateOut() {
      var day = date.daysBetween(new Date().Format("yyyy-MM-dd"), this.g_searchParam.startDate)

      if (day < 0 || this.g_searchParam.startDate == '') {
        this.initDate()
      }

    },
    checkinDateChange(val) {
      //修改入住时间后离店时间也修改
      this.reWriteQueryDate(val, new Date(val).DateAdd('d', 1).Format('yyyy-MM-dd'));
      //重读数据
      this.initState()
      this.searchHotel()
    },
    checkoutDateChange(val) {
      //修改离店时间时只要修改离店时间，因为离店时间不可能小于入店时间
      this.reWriteQueryDate(this.g_searchParam.startDate, val);
      //重读数据
      this.initState()
      this.searchHotel()
    },
    reWriteQueryDate(checkinDate, checkoutDate) {
      
      console.log(searchParam)
      
      var searchParam = this.g_searchParam;
      searchParam.startDate = checkinDate;
      searchParam.endDate = checkoutDate;

      console.log(searchParam)
      this.setG_searchParam(searchParam);
    },

    // 清空搜索选项
    clearSearchParam(){
      var searchParam=this.g_searchParam;
      //searchParam.cityId='';
      searchParam.hotelCode='';
      //searchParam.startDate='';
      //searchParam.endDate='';
      searchParam.promotionType='';
      searchParam.HotelTypeId='';
      searchParam.areaId='';
      searchParam.pointX='';
      searchParam.pointY='';
      searchParam.PointType='';
      searchParam.PointText='';
      searchParam.Sort='';
      searchParam.Flag='';
      searchParam.SortType='asc';
      searchParam.PageIndex='1';
      searchParam.PageSize='10';


      this.setG_searchKeyWord('');

      return ;
    },
    goCity(){
      this.$router.push({ path: '/search/selectCity' })
    },
   // 检验是否登入，APP 小程序 跳转到该页面需要检索到自动登入 功能
    CheckLogin(){
     if (this.$route.query.userId!=undefined && this.$route.query.sign!=undefined) {
      var params = new this.URLSearchParam();
      params.append("userId", this.$route.query.cardNo);
      params.append("sign", this.$route.query.sign);
 
      this.$http.post(api.CheckLoginState(), params.toParam()).then(data => {
        if(data.Result){ 
             // 自动登入成功--保存登录信息
             this.loginState=true;
            console.log("========测试========")
            console.log(this.loginState)
        
            var result = data.Data
            this.SaveUserInfo(result)
          }
        });
        }
    },
     
    SaveUserInfo(result) {
      // 保存登录信息
      console.log("-------------")
      var UserInfo = result
      console.log(result);
      if (UserInfo.Card_Kind_Diplay == '网上数字卡') {
        UserInfo.Card_Kind_Diplay = '数字卡'
      }

      UserInfo.OrderRefresh1 = true
      UserInfo.OrderRefresh2 = true
      UserInfo.OrderRefresh3 = true
      // 保存登录信息
      this.setG_UserInfo(UserInfo)
    },

  },
  computed: {
    ...mapGetters([
      'g_city',
      'g_searchParam',
      'g_searchKeyWord',
      'g_currentInfo',
      'g_UserInfo',
    ]),
    checkInDateFormat() {
      return new Date(this.g_searchParam.startDate).Format('M月D日')
    },
    checkOutDateFormat() {
      return new Date(this.g_searchParam.endDate).Format('M月D日')
    },
    checkinMinDate() {
      //最小入住日期为当天
      return new Date()
    },
    checkinMaxDate() {
      //最大入住日期为3个月内
      return new Date().DateAdd('d', 365)//入住日期最大为3个月内
    },
    checkoutMinDate() {
      //最小离店日期比当前入住时间多一天
      return new Date(this.g_searchParam.startDate).DateAdd('d', 1)
    },
    checkoutMaxDate() {
      //最大离店日期比当前入住时间多14天
      return new Date(this.g_searchParam.startDate).DateAdd('d', 14)
    },
    day() {

      var d1 = new Date(this.g_searchParam.startDate)
      var d2 = new Date(this.g_searchParam.endDate)

      console.log( this.g_searchParam.endDate )

      var s1 = d1.getTime(), s2 = d2.getTime();

      if(   this.g_searchParam.isZeroRoom  ){
        return parseInt((s2 - s1) / 1000 / (24 * 60 * 60))+1;
      }

      return parseInt((s2 - s1) / 1000 / (24 * 60 * 60));
    }
  },
  watch: {
    g_searchParam: {
      handler: function(val, oldVal) {
        // if(val.Sort == ''){
        this.change = true
        // }
      },
      deep: true
    },
  },

  activated() {

    // 初始化时间
    this.checkDateOut()
    
    this.$el.scrollTop = 0

    // 主页过来时候，此页面限制信息销毁【这个不要了。】
    if (this.$route.query.BrandID) {

      // 清空限制
      this.clearSearchParam();

      // 获取到酒店品牌页跳转过来的信息
      this.ServiceID = [0];
      this.DiscountID = [0];
      this.SortID = 0;

      //  插入数据
      var BID = this.$route.query.BrandID;

// 40 东方, 00豪泰，30联盟，50青皮树，70贝壳
      if( BID == '40' )  
        this.BrandID = [1];
      else if( BID == '00' )
        this.BrandID = [5];
      else if( BID == '30' )
        this.BrandID = [6];
      else if( BID == '50' )
        this.BrandID = [7];
      else if( BID == '70' )
        this.BrandID = [8];

  // 格美 20// 格雅 21// 格菲 22   下面的还没上线
      else if( BID == '20' )
        this.BrandID = [2];
      else if( BID == '21' )
        this.BrandID = [3];
      else if( BID == '22' )
        this.BrandID = [4];

      else if( BID == '81' )
        this.BrandID = [9];

      else if( BID == '90' )
        this.BrandID = [10];

      this.LimitBrand();

      return
    }


    if (this.$route.query.Flag=='1') 
    {
       this.DiscountID = [7];
    }
    else if(this.$route.query.Flag=='2')
    {
       this.DiscountID = [5];
    }
    else if(this.$route.query.Flag=='3')
    {
        this.DiscountID = [4];
    }

    if (this.HotelList.length == 0) {
      this.change = true
    }
    if (this.change == true) {
      this.initState()
      this.activeTab = 'tab1'
      this.searchHotel();
    }
    else if (!this.stop) {
      window.addEventListener('scroll', this.loadMore)
    }
    this.change = false;


     //获取登录状态
    var params = new this.URLSearchParam();
     console.log("2020-05-27 01")
    console.log(this.g_UserInfo.Card_no)
    
    params.append('cardNo', this.g_UserInfo ? this.g_UserInfo.Card_no : '')
    this.$http.post(api.loginState(), params.toParam()).then((res) => {     
      if (res.Result) {
        console.log("2020-05-27 02")
        this.loginState = true
      }
      else {
        console.log("2020-05-27 03")
        this.CheckLogin(); 
      }
    })  

  },
  deactivated() {
    window.removeEventListener('scroll', this.loadMore)
  }
}
</script>





<style lang="less" scoped>
// 酒店筛选
.TopMenuList {
  width: 100%;
  line-height: 0.8rem;
  border-bottom: 1px #eee solid;
  padding: 0 0.2rem;
}

.GreeenFont {
  color: #27ba69;
}

.GreenButton {
  margin: 0.3rem 0;
  font-size: 0.3rem;
  color: white;
  height: 0.75rem;
  width: 6.9rem;
  background-color: #27ba69;
  border-radius: 0.04rem;
  border: 0;
  outline: none;
  height: 0.8rem;
}

// 右边按钮
.RightAnNiu {
  width: 0.35rem;
  margin-top: 0.2rem;
  float: right;
}
</style>


<style lang="less">
@import "../../assets/common.less";
@import (reference) "../../assets/theme.less";
.formatdate {
  width: 100%;
  top: 0.1rem;
  left: 0;
  position: absolute;
} //以图片形式放置，目前不用。因为看起来可以了  20170829
.hotelLoc {
  img {
    position: relative;
  }
}

img.parking {
  margin-right: 6px;
  height: 0.2rem;
}

img.food {
  margin-right: 6px;
  height: 0.2rem;
}

img.wifi {
  margin-right: 6px;
  height: 0.2rem;
}

img.pp {
  margin-right: 6px;
  height: 0.2rem; // top: 0.04rem;
}

img.zp3 {
  margin-right: 6px;
  height: 0.2rem; // top: 0.04rem;
}

img.zp6 {
  margin-right: 6px;
  height: 0.2rem; // top: 0.04rem;
}

img.selfservice {
  margin-right: 6px;
  height: 0.2rem;
}

.scrollDiv {
  height: auto;
  -webkit-overflow-scrolling: touch;
  background-color: #F1F1F1;
  .mu-appbar {
    .mu-appbar-title {
      text-align: center;
      margin-top: -10px;
    }
  }

  .topBlock {
    div {
      width: 33%;
      height: 0.9rem;
      text-align:center;
      margin: auto;
      color: @secondBlack;
      font-size: 0.28rem;
      small {
        font-size: 0.22rem;
        color: @textColor;
      }
    }
    .middle {
      line-height:0.9rem;
      span {
        color: @primaryOrange;
      }
    }
  }

  .divDivider {
    background-color: #F9F9F9;
    padding-bottom: 10px;
    clear: both;
  }

  .searchDiv {
    display: flex;
    color: @textColor;
    height: 0.81rem;
    font-size: 0.28rem;
    line-height: 0.39rem;
    span {
      margin: auto;
      height: 0.28rem;
      display: flex;
      .icon {
        height: 0.28rem;
        margin: auto;
      }
    }
    background-color:#FFF;
    color:@textColor;
    margin:0.2rem 0;
  }

  .mu-tabs {
    margin-top: 5px;
    background-color: #fff;
    .mu-tab-link {
      color: @greyFontColor;
    }
    .mu-tab-active {
      color: @primaryColor;
    }
    .mu-text-field-line {
      background-color: #FFF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// list.vue?2d814d4d